var _circle, _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgInfo = function SvgInfo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    fill: "none",
    viewBox: "0 0 29 29",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.15,
    cy: 14.976,
    r: 14,
    fill: "#E1E0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D03FC",
    d: "M12.072 19.347a.532.532 0 0 0-.547.547v1.285c0 .328.218.547.547.547h4.156c.3 0 .547-.219.547-.547v-1.285c0-.3-.246-.547-.547-.547h-.547v-5.824c0-.3-.246-.547-.547-.547h-3.062a.532.532 0 0 0-.547.547v1.313c0 .3.218.546.547.546h.546v3.965h-.546Zm2.078-11.62a1.978 1.978 0 0 0-1.969 1.968 1.96 1.96 0 0 0 1.969 1.969 1.978 1.978 0 0 0 1.969-1.97c0-1.066-.903-1.968-1.97-1.968Z"
  })));
};
export default SvgInfo;